import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import Modal from '@mui/material/Modal';
import LoadingInfynito from "../Shared/LoadingInfynito";
import Box from '@mui/material/Box';

import infynitoStep001 from "../Shared/img/infynito-step001.svg";
import infynitoStep002 from "../Shared/img/infynito-step002.svg";
import infynitoStep003 from "../Shared/img/infynito-step003.svg";

import { Parser } from 'html-to-react'

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

export const IntroInLanding = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const [customizationData, setCustomizationData] = useState({
        idCustomization: "",
        idUtente: "",
        idBasicModel: 0,
        moodType: "",
        language: ""
    });

    const customizationCtx = useContext(CustomizationContext);
    const localizationCtx = useContext(LocalizationContext);
    const pathMainImage = "/images/" + props.modelCode + "/main.jpg"


    const startConfiguration = async () => {
        setIsLoading(true);
        const response = await fetch("/api/customization/start/" + props.modelCode + "/" + props.cultureCode);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                customizationCtx.updateCustomizationData(data);
                setCustomizationData(data);
                setIsLoading(false);
                goToConfigurator();
            } else {
                setIsLoading(false);
                props.feedbackCallback("error", "Error initializing configuration", true);
            }

        } else {
            setIsLoading(false);
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }
    }

    const handleStartConfiguration = () => {
        startConfiguration();
    };

    const goToConfigurator = () => {

        let url = "/" + props.cultureCode + "/";

        if (props.modelCode === "Infynito80") {
            url += "InteractiveConfiguratorFerrettiInfynito80";
        }

        history.push({
            pathname: url,
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);



    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'white',
        boxShadow: 24,
        p: 4,
    };

    const handleClose = () => {
        setIsLoading(false);
    }

    return (
        <>
            <div className="container-fluid">
                <div className="container pb-5">
                    <div className="row">
                        <div className="col text-center">
                            <h3 className="dots-gallery"></h3>
                        </div>
                    </div>
                </div>
                <div className="header-section text-white text-center py-5" id="Configurator"><h1 className="h1">{props.cultureCode === "en-us" ? "Configurator" : "Configuratore"}</h1></div>
                <div className="row py-5" >                  
                    <div className="col-lg-6 col-xl-4">
                        <div className="valign py-5 py-lg-0">
                            <div className="align-middle d-table-cell">
                                <div className="d-table mx-auto px-4">
                                    <h3 className="text-white mb-3">{Parser().parse(localizationCtx.localizationData.payOff)}</h3>
                                    <div className="d-block mb-3">
                                        <img src={infynitoStep001} alt="" /><span className="ico-label">{localizationCtx.localizationData.actionConfigure}</span>
                                    </div>
                                    <div className="d-block mb-3">
                                        <img src={infynitoStep002} alt="" /><span className="ico-label">{localizationCtx.localizationData.actionReview}</span>
                                    </div>
                                    <div className="d-block mb-3">
                                        <img src={infynitoStep003} alt="" /><span className="ico-label">{localizationCtx.localizationData.actionSend}</span>
                                    </div>
                                    <div className="text-center">
                                    <button type="button" className="btn btn-configurator mt-5 text-uppercase" onClick={handleStartConfiguration}>{localizationCtx.localizationData.actionStart}</button>
                                    </div>
                                    <div className="d-block d-sm-none text-white py-5">
                                        <p className="text-intro pr-lg-5 mr-lg-5">{localizationCtx.localizationData.landascapeMode}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-8 d-none d-lg-block">
                        <div className="valign">
                            <div className="align-middle d-table-cell">
                                <div className="d-table mx-auto">
                                    <img src={pathMainImage} alt="" className="w-100 main-image-configurator" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                open={isLoading}
                onClose={handleClose}
            >

                <Box sx={style}>
                    <LoadingInfynito message={localizationCtx.localizationData.loadingStart} />
                </Box>

            </Modal>

        </>
    );
};

export default IntroInLanding;
